// 真实英文名库
import { isEnglish } from '@/common/locale'

const englishNames = [
    'Jack', 'Mike', 'David', 'James', 'John', 'Robert', 'William', 'Thomas',
    'Emma', 'Olivia', 'Sophia', 'Ava', 'Isabella', 'Mia', 'Amelia', 'Harper',
    'Kevin', 'Jason', 'Eric', 'Henry', 'Leo', 'Lucas', 'Ethan', 'Daniel',
    'Chris', 'Brian', 'Mark', 'Paul', 'Steven', 'Andrew', 'Matthew', 'Joshua'
]

// 生成随机名称
const generateRealName = () => {
    // 随机选择名字
    const name = englishNames[Math.floor(Math.random() * englishNames.length)]
    
    // 随机生成3-4位数字
    const number = Math.floor(Math.random() * 9000 + 1000)
    const maskIndex = Math.floor(name.length * 0.6)
    const maskedName = name.substring(0, maskIndex) + '***'
    return `${maskedName}${number}`
    // 随机决定格式（30%概率带后缀）
    // const format = Math.random()
    
    // if(format < 0.3) {
    //     // 带字母后缀格式: JackA123
    //     const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    //     const suffix = letters[Math.floor(Math.random() * letters.length)]
    //     return `${name}${suffix}${Math.floor(Math.random() * 900 + 100)}`
    // } else if(format < 0.5) {
    //     // 带星号掩码: Ja***4527
    //     const maskIndex = Math.floor(name.length * 0.6)
    //     const maskedName = name.substring(0, maskIndex) + '***'
    //     return `${maskedName}${number}`
    // } else {
    //     // 标准格式: Jack4527
    //     return `${name}${number}`
    // }
}
// 随机获取商品
const getRandomGoods = (goodsList) => {
    return goodsList[Math.floor(Math.random() * goodsList.length)]
}
const generateNotice = (goodsList) => {
    const name = generateRealName()
    const goods = getRandomGoods(goodsList)
    const now = new Date()
    const dateStr = `${String(now.getMonth() + 1).padStart(2, '0')}/${String(now.getDate()).padStart(2, '0')}`

    // 按当前站点语言输出公告：英文使用英文模板，中文（简/繁）保持原中文
    if (isEnglish()) {
        return `${dateStr} Congratulations to ${name}! With a cumulative spending of ${goods.goods_price} RMB, you have received "${goods.goods_name.slice(0, 9)}" as a gift. May you find true happiness in the resonance of souls.`
    }

    return `${dateStr} 恭喜老板${name}累计消费【${goods.goods_price}RMB】获赠【${goods.goods_name.slice(0,9)}】一个，愿老板在灵魂的共振中寻得性福。`
}
const generateNotice_lottery = () => {
    const name = generateRealName()
    return {
        tag:'VIP会员',
        name:name,
        desc:'恭喜老板黄金卡认证成功',
        note:'已添加美眉微信🥰🥰🥰'
    }
}
export default {
    generateNotice:generateNotice,
    generateNotice_lottery:generateNotice_lottery
}